import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { debounceTime, filter, Subject, takeUntil } from 'rxjs';

interface WrapperProps extends FormlyFieldProps {
  group: string;
  interpolateLabel?: boolean;
}

@Component({
    selector: 'lockton-apps-default-wrapper',
    templateUrl: './default-wrapper.component.html',
    styleUrls: ['./default-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DefaultWrapperComponent
  extends FieldWrapper<FormlyFieldConfig<WrapperProps>>
  implements OnInit, AfterViewInit, OnDestroy
{
  readonly destroyer$: Subject<void> = new Subject();

  constructor(
    private readonly host: ElementRef,
    private readonly renderer: Renderer2
  ) {
    super();
  }

  ngOnInit(): void {
    const formlyField: HTMLElement =
      this.host.nativeElement.parentElement.closest('formly-field');

    if (this.field.id) {
      this.renderer.setAttribute(formlyField, 'id', `field_${this.field.id}`);
    }

    if (this.props.group) {
      this.renderer.setAttribute(
        formlyField,
        'data-group-item',
        this.props.group
      );
    }
  }

  ngAfterViewInit(): void {
    this.checkForDependantStepsIds();
  }

  ngOnDestroy(): void {
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  private checkForDependantStepsIds(): void {
    this.options.fieldChanges
      ?.pipe(
        debounceTime(100),
        takeUntil(this.destroyer$),
        filter(
          ({ field: { key, props }, type }) =>
            type == 'valueChanges' &&
            key === this.key &&
            props?.['dependantStepsIds']?.length
        )
      )
      .subscribe(({ field }) => {
        field.props?.['dependantStepsIds'].forEach(
          this.options.formState.affectedStepsIds.add,
          this.options.formState.affectedStepsIds
        );
      });
  }
}
